<template>
    <el-dialog
        :closeOnClickModal="false"
        :title="'逾期明细查询'"
        :visible="true"
        :before-close="beforeClose"
        :class="'performanceOverDetailSearch'"
        :width="'1000px'"
    >
        <div class="performanceOverDetailSearchWapper">
            <div class="performanceOverDetailSearchInfo">
                <el-row :gutter="24">
                    <el-col :span="12">
                        <div class="item">
                            <span class="itemLabel">发车单号：</span>
                            <span class="itemValue">{{
                                rowData.dispatchNo
                            }}</span>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="item">
                            <span class="itemLabel">运输单号：</span>
                            <span class="itemValue">{{ rowData.taskNo }}</span>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div class="performanceOverDetailSearchList" v-loading="loading">
                <m-table
                    :columns="config.table.columns"
                    :actions="config.table.action"
                    :rows="totalData"
                    :height="config.table.height"
                ></m-table>
                <el-row type="flex" class="row-bg" justify="space-between">
                    <m-page
                        ref="page"
                        :current-page="query.pageNo"
                        :pageData="config.page"
                        :total="pageTotal"
                        @on-page-change="pageChange"
                        @on-size-change="sizeChange"
                    ></m-page>
                </el-row>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import mTable from '@/components/lots/tableBox/Index.vue';
import mPage from '@/components/otpPanel/mPage';
import config from './config.js';
import { dictWithUrl } from '@/components/lots/api.js';
import { getReceiptOverdueDetail } from '@/modules/transport/otp/api/performanceReceiptSign.js';
import { CURRENT_OVERDUE_TYPE } from '../../util.js';
export default {
    name: 'performanceOverDetailSearch',
    components: {
        mTable,
        mPage
    },
    props: {
        rowData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            config: config,
            loading: false,
            totalData: [],
            pageTotal: 0,
            query: { pageNo: 1, pageSize: 10 },
            dictData: {}
        };
    },
    methods: {
        /**
         * @description 数据字典列表
         * @param {String} OVER_DUE_TYPE 逾期类型
         * @param {String} OVERDUE_ARRIVE_1 一级逾期原因 注：一级逾期原因都使用同一个数据字典，只是二级逾期原因不同
         * @param {String} OVERDUE_ARRIVE_2 到货逾期二级原因
         * @param {String} OVERDUE_RECEIPT_2 签收逾期二级原因
         * @param {String} PUPPLIER_TURN_OVER 供方移交二级逾期原因
         * @param {String} ACCOUNT_TURN_OVER 结算移交二级逾期原因
         * @param {String} ACCOUNT_TURN_OVER_SURE 结算移交确认二级逾期原因
         */
        getDictData () {
            return dictWithUrl('OVER_DUE_TYPE,OVERDUE_ARRIVE_1,OVERDUE_ARRIVE_2,OVERDUE_RECEIPT_2,PUPPLIER_TURN_OVER,ACCOUNT_TURN_OVER,ACCOUNT_TURN_OVER_SURE').then(res => {
                if (res && +res.code === 0) {
                    this.dictData = res.data;
                }
            });
        },
        /**
         * @description 查询参数
         * @param {String} taskNo 运输单号
         */
        getSearchData () {
            return {
                ...this.query,
                param: { taskNo: this.rowData.taskNo }
            };
        },
        /**
         * @description 获取逾期明细列表
         */
        getList () {
            this.loading = true;
            const searchData = this.getSearchData();
            getReceiptOverdueDetail(searchData).then(res => {
                if (res && +res.code === 0) {
                    this.pageTotal = res.data.totalCount || 0;
                    this.totalData = this.formatResponseData(res.data.list || []);
                }
            }).finally(() => { this.loading = false; });
        },
        /**
         * @description 格式化逾期明细列表数据
         */
        formatResponseData (data) {
            data.forEach(v => {
                v.overdueTypeName = v.overdueType ? this.dictData.OVER_DUE_TYPE[v.overdueType] : '';
                v.overdueReasonName = (v.overdueReason ? this.dictData.OVERDUE_ARRIVE_1[v.overdueReason] : '') || v.levelAName || '';
                const secondOverdueObj = this.dictData[CURRENT_OVERDUE_TYPE[v.overdueType]];
                v.overdueReasDetailName = (v.overdueReasDetail ? secondOverdueObj[v.overdueReasDetail] : '') || v.levelBName || '';
            });
            return data;
        },
        // 切换当前分页
        pageChange (pageNo) {
            this.query.pageNo = pageNo;
            this.getList();
        },
        // 切换当前分页显示条数
        sizeChange (pageSize) {
            this.query.pageNo = 1;
            this.query.pageSize = pageSize;
            this.getList();
        },
        beforeClose () {
            this.$emit('update:overdueDetailSearchVisible', false);
        }
    },
    async mounted () {
        await this.getDictData();
        this.getList();
    }
};
</script>
<style lang="less">
.performanceOverDetailSearch {
    .performanceOverDetailSearchInfo {
        border-bottom: 1px dashed #ddd;
        padding-bottom: 10px;
        padding-left: 30px;
        .item {
            line-height: 40px;
            .itemLabel {
                color: #999;
                display: inline-block;
                width: 64px;
            }
            .itemValue {
                color: #333;
            }
        }
    }
    .performanceOverDetailSearchList {
        margin-top: 22px;
    }
    .row-bg {
        margin-top: 15px;
        text-align: right;
        .table-pagination {
            width: 100%;
        }
    }
}
</style>
